import React from 'react';
import { createPortal } from 'react-dom';
import { View, CloseIcon } from '@upstox/upstox-ui';
import * as css from './Overlay.style';

interface Props {
  onClose?: () => void;
}

const Overlay: React.FC<Props> = ({ onClose, children }) => {
  return createPortal(
    <View css={css.overlay} flexDirection="column" alignItems="center">
      <View
        flexDirection="column"
        style={{ maxWidth: '100%', margin: 'auto', padding: '35px 0' }}
      >
        <View justifyContent="flex-end" style={{ position: 'relative' }}>
          <CloseIcon
            size="large"
            color="text.white"
            style={{
              cursor: 'pointer',
              position: 'absolute',
              right: 10,
              top: '15px',
              zIndex: 9999,
            }}
            onClick={onClose}
          />
        </View>
        <div className="sliderWrapper">{children}</div>
      </View>
    </View>,
    document.getElementById('overlayRoot'),
  );
};

export default Overlay;
